import { Component, DestroyRef, inject, Input, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatIcon } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";
import { TranslocoPipe } from "@jsverse/transloco";
import { LOREN_ROUTES } from "../../../../../../constants/loren-routes.constants";
import { LorenBottomSheetDataConfig } from "../../../../../loren-bottom-sheet/interfaces/loren-bottom-sheet-config.interface";
import { LorenFeatureToggleService } from "../../../../../../services/loren-feature-toggle-service/loren-feature-toggle.service";
import { LorenBottomSheetComponent } from "../../../../../loren-bottom-sheet/components/loren-bottom-sheet/loren-bottom-sheet.component";
import { LorenTourService } from "../../../../../../services/loren-tour-service/loren-tour.service";
import { LorenFeature } from "../../../../../../enums/loren-feature.enum";
import { LorenSidenavTourSteps } from "../../../../../../constants/loren-tour-steps.constants";
import { TourAnchorMatMenuDirective } from "ngx-ui-tour-md-menu";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  selector: "loren-help-button",
  imports: [
    CommonModule,
    MatTooltip,
    TranslocoPipe,
    MatIcon,
    TourAnchorMatMenuDirective,
  ],
  templateUrl: "./loren-help-button.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./loren-help-button.component.scss",
})
export class LorenHelpButtonComponent {
  private router = inject(Router);
  private bottomSheet = inject(MatBottomSheet);
  private lorenTourService = inject(LorenTourService);
  private lorenFeatureToggleService = inject(LorenFeatureToggleService);

  private readonly destroyRef = inject(DestroyRef);
  @Input() isHandset: boolean;

  readonly helpAnchorId = LorenSidenavTourSteps.find(
    (x) => x.anchorId === "help"
  ).anchorId;

  handleHelpClick($event) {
    const bottomSheetConfig: LorenBottomSheetDataConfig = {
      items: [],
    };
    this.lorenFeatureToggleService
      .userHasFeature(LorenFeature.GENERIC_RULES)
      .pipe(
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((x) => {
        bottomSheetConfig.items.push({
          title: `tour.app_tour`,
          subTitle: "tour.app_tour_subtitle",
        });
        if (x) {
          bottomSheetConfig.items.push({
            title: `tour.automation_plan_tour`,
            subTitle: `tour.automation_plan_subtitle`,
          });
        }
        bottomSheetConfig.items.push({
          title: `features.faq`,
          subTitle: `features.faq_description`,
        });
        this.openBottomSheetComponent(bottomSheetConfig);
      });
    $event.preventDefault();
    return;
  }

  private openBottomSheetComponent(
    bottomSheetConfig: LorenBottomSheetDataConfig
  ) {
    const ref = this.bottomSheet.open(LorenBottomSheetComponent, {
      data: bottomSheetConfig,
    });

    ref.instance.itemClick.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((res) => {
      const bottomSheetConfigTitles = bottomSheetConfig.items.map(
        (i) => i.title
      );
      if (res.title === bottomSheetConfigTitles[0]) {
        this.lorenTourService.triggerCommonApplicationTour();
      } else if (res.title === bottomSheetConfigTitles[1]) {
        this.lorenTourService.triggerAutomationPlanTour();
      } else {
        this.router.navigate([LOREN_ROUTES.FAQ]);
      }
    });
  }
}
